export default {
    title_list: 'Века',
    title_page: 'Век',
    title_create_page: 'Создать век',
    title_edit_page: 'Изменить век',

    filter: {
        labels: {
            title: 'Название',
        }
    },

    table: {
        labels: {
            id: 'ID',
            title: 'Название',
            position: 'Порядок',
        }
    },

    buttons: {

    },

    form: {
        title: 'Название',
        position: 'Порядок',
        visible: 'Отображение',
        min: 'Минимальный год',
        max: 'Максимальный год',
    },
}
